import { format } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import Moment from 'react-moment';
import Button from '@components/Button';
import TextField from '@components/TextField';
import AdminConfig from '@config/admin';
import Icon from '@material-ui/core/Icon';
import Alert from '@material-ui/lab/Alert';
import { display, visibility } from '@material-ui/system';
import { apiClient } from '@services/api';
import { dateLocale, slugfy, translator } from '@utils/helpers';
import NumberFormat from 'react-number-format';
import Modal from '@components/Modal';
import CircularProgress from '@material-ui/core/CircularProgress';
import calendar from '@assets/images/icons/calendar.png';
import clock from '@assets/images/icons/clock.png';
import person from '@assets/images/icons/person.png';
import '@css/Admin/index.scss';
import {
  Link,
  Route,
  Switch,
  useHistory,
  useLocation,
  useParams, useRouteMatch
} from "react-router-dom";
import ReactToPrint from 'react-to-print';
import Header from './partials/Header';
import Checkbox from '@components/Checkbox';

const formatDate =(date)=>{
  if(date){
    const newDate = new Date(date)
    return `${newDate.toJSON().split('T')[0].split('-')[2]}/${newDate.toJSON().split('T')[0].split('-')[1]}/${newDate.toJSON().split('T')[0].split('-')[0]}`
  }
}
class Content extends React.Component {
  render() {
    const props = this.props;
    if (!props.voucher || !props.voucher.customerData) return null;
    const idiom = (props.voucher.customerData.language || 'pt').toUpperCase();
    const tr = (key) => translator(idiom, 'voucher', key);
    const payment_status = {
      accomplished: { label: tr('paid'),    color: '#22c55e' },
      pending:      { label: tr('pending'), color: '#f59e0b' },
      partial:      { label: tr('partial'), color: '#38bdf8' },
    };

    const language = {
      pt: 'Português',
      en: 'Inglês',
      es: 'Espanhol'
    };

    let lastPaymentId = 0;
    props.voucher.payments.forEach(p => { if (p.id > lastPaymentId) lastPaymentId = p.id; });
    const lastPayment = props.voucher.payments.find(p => p.id === lastPaymentId);
    const paidTotal = props.voucher.payments.reduce((acc, p) => acc + Number(p.total), 0);
    const payStatus = payment_status[lastPayment?.current_status] || { label: lastPayment?.current_status || '—', color: '#64748b' };

    const formatHour = time => {
      if (time) {
        const parts = time.split(':');
        const hour = new Date().setHours(parts[0], parts[1]);
        return format(hour, 'HH:mm');
      }
      return null;
    };

    const calcAdultsValue = (v) => {
      const val = Number(v?.adults_total_amount);
      const qty = Number(v?.adults_total);
      return qty > 1 ? val / qty : val;
    };

    const calcKidsValue = (v) => {
      const val = Number(v?.kids_total_amount);
      const qty = Number(v?.kids_total);
      return qty > 1 ? val / qty : val;
    };

    const cleanText = (text) => {
      if (!text) return '';
      return text
        .replace(/color\s*:\s*[^;}"']+;?/gi, '')
        .replace(/width\s*:\s*\d+px/gi, 'max-width:100%')
        .replace(/\s+width=["']\d+["']/gi, '')
        .replace(/<table/gi, '<table style="width:100%;max-width:100%;table-layout:fixed;word-break:break-word;"')
        .replace(/<img/gi, '<img style="max-width:100%;height:auto;"');
    };

    const getTimes = (v) => {
      if (v.travel.tour_period === 'fullday') return tr('fullday');
      if (!v.times || v.times === 'null') return '-';
      // Traduz fragmentos PT vindos do banco ("Meio-período - Manhã")
      return String(v.times)
        .replace(/Meio-per[íi]odo/gi, tr('halfday'))
        .replace(/Manh[ãa]/gi, tr('morning'))
        .replace(/Tarde/gi, tr('afternoon'))
        .replace(/Integral/gi, tr('fullday'));
    };

    // ── Estilos inline ──────────────────────────────────────────────────────────
    const s = {
      wrap:       { fontFamily: "'Poppins', Arial, sans-serif", background: '#f0f4f8', padding: '0 0 40px' },
      inner:      { maxWidth: '1400px', margin: '0 auto', padding: '0 24px' },
      // Cabeçalho
      hdr:        { background: '#172B4D', padding: '28px 24px', textAlign: 'center' },
      hdrLogo:    { height: '52px', display: 'block', margin: '0 auto 10px' },
      hdrName:    { color: '#e8f0fb', fontSize: '18px', fontWeight: 700, margin: 0 },
      hdrSub:     { color: '#8ba5c4', fontSize: '12px', margin: '4px 0 0' },
      teal:       { background: '#11A1A7', height: '3px' },
      // Cards
      card:       { background: '#fff', borderRadius: '10px', border: '1px solid #e0e7ef', marginTop: '16px', overflow: 'hidden' },
      cardTitle:  { background: '#f8fafc', padding: '12px 18px', fontSize: '13px', fontWeight: 700, color: '#172B4D', borderBottom: '1px solid #e0e7ef', textTransform: 'uppercase', letterSpacing: '0.5px' },
      row:        { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '10px 18px', borderBottom: '1px solid #f1f5f9', gap: '12px' },
      rowLast:    { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '10px 18px', gap: '12px' },
      rowLabel:   { fontSize: '13px', color: '#555', fontWeight: 600, flex: '0 0 auto', maxWidth: '50%' },
      rowValue:   { fontSize: '13px', color: '#172B4D', textAlign: 'right', wordBreak: 'break-word' },
      // Passeio
      tourCard:   { background: '#fff', borderRadius: '10px', border: '1px solid #e0e7ef', borderLeft: '4px solid #11A1A7', marginTop: '12px', overflow: 'hidden' },
      tourName:   { padding: '12px 18px', fontSize: '14px', fontWeight: 700, color: '#172B4D', borderBottom: '1px solid #e0e7ef' },
      // Badge status
      badge:      (color) => ({ display: 'inline-block', background: color + '22', color, border: `1px solid ${color}`, borderRadius: '20px', padding: '2px 12px', fontSize: '12px', fontWeight: 700 }),
      // Termos
      termsWrap:  { background: '#fff', borderRadius: '10px', border: '1px solid #e0e7ef', marginTop: '16px', padding: '18px' },
      termsText:  { fontSize: '12px', color: '#555', lineHeight: '1.7', wordBreak: 'break-word', overflowX: 'hidden' },
      // Assinatura
      signBox:    { background: '#fff', borderRadius: '10px', border: '1px solid #e0e7ef', marginTop: '16px', padding: '20px 18px' },
      signHash:   { background: '#f0f4f8', borderRadius: '6px', padding: '10px 12px', fontSize: '10px', wordBreak: 'break-all', fontFamily: 'monospace', color: '#172B4D', marginTop: '10px' },
      // Rodapé
      footer:     { textAlign: 'center', marginTop: '24px', fontSize: '11px', color: '#8ba5c4' },
    };
    // ── Novo layout responsivo (dark, single-column) ────────────────────────────
    return <div style={s.wrap}>

      {/* ── Cabeçalho empresa ── */}
      <div style={s.hdr}>
        {props.voucher.company.logo
          ? <img src={`${process.env.REACT_APP_BASE_IMAGE_URL}/${props.voucher.company.logo}`} alt={props.voucher.company.name} style={s.hdrLogo} />
          : <p style={s.hdrName}>{props.voucher.company.name}</p>
        }
        <p style={s.hdrName}>{props.voucher.company.name}</p>
        <p style={s.hdrSub}>{translator(idiom, 'voucher', 'rut')}: {props.voucher.company.rut} · Tel: {props.voucher.company.phone}</p>
        <p style={{ ...s.hdrSub, marginTop: '2px' }}>{props.voucher.company.address} · {props.voucher.company.district} · {props.voucher.company.state}</p>
      </div>
      <div style={s.teal} />

      <div style={s.inner}>

        {/* ── Dados do cliente ── */}
        <div style={s.card}>
          <div style={s.cardTitle}>{translator(idiom, 'voucher', 'customers_data')}</div>
          <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'customer_name')}</span><span style={s.rowValue}>{props.voucher.reservationData.customer_name}</span></div>
          <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'phone')}</span><span style={s.rowValue}>{props.voucher.reservationData.customer_telephone}</span></div>
          <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'email')}</span><span style={s.rowValue}>{props.voucher.customerData.email}</span></div>
          <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'document')}</span><span style={s.rowValue}>{props.voucher.customerData.document}</span></div>
          {/* Hospedagem por região */}
          {(() => {
            const reservations = props.voucher.reservations;
            if (reservations && reservations.length > 0) {
              // Group by region, keeping the first occurrence of each unique region
              const seen = new Map();
              reservations.forEach(r => {
                const region = r.travel?.region_name || r.travel?.region || (typeof r.tour_region === 'string' ? r.tour_region : null) || 'Geral';
                if (!seen.has(region)) {
                  seen.set(region, {
                    hotel: r.hotel_name || r.hotel || '',
                    address: r.address_hotel || '',
                    room: r.room_number || null,
                  });
                }
              });
              return Array.from(seen.entries()).map(([region, info], i) => {
                const hotelLine = [info.hotel, info.address].filter(Boolean).join(' — ');
                const roomSuffix = info.room ? `, ${tr('room')}: ${info.room}` : '';
                const valueText = `${hotelLine}${roomSuffix}`;
                const isLast = i === seen.size - 1;
                return valueText ? (
                  <div key={region} style={isLast ? s.rowLast : s.row}>
                    <span style={s.rowLabel}>{tr('lodging')} {region}</span>
                    <span style={s.rowValue}>{valueText}</span>
                  </div>
                ) : null;
              });
            }
            // Fallback: use reservationData fields
            const fallbackHotel = props.voucher.reservationData?.hotel_name || props.voucher.reservationData?.hotel || '';
            const fallbackAddress = props.voucher.reservationData?.address_hotel || '';
            const fallbackRoom = props.voucher.reservationData?.room_number || null;
            const fallbackLine = [fallbackHotel, fallbackAddress].filter(Boolean).join(' — ');
            const fallbackRoomSuffix = fallbackRoom ? `, ${tr('room')}: ${fallbackRoom}` : '';
            const fallbackValue = `${fallbackLine}${fallbackRoomSuffix}`;
            return fallbackValue ? (
              <div style={s.rowLast}>
                <span style={s.rowLabel}>{tr('lodging')}</span>
                <span style={s.rowValue}>{fallbackValue}</span>
              </div>
            ) : null;
          })()}
        </div>

        {/* ── Informações de pagamento ── */}
        <div style={s.card}>
          <div style={s.cardTitle}>{translator(idiom, 'voucher', 'payment_about')}</div>
          <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'references')}</span><span style={s.rowValue}>{props.voucher.references}</span></div>
          <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'purchase_date')}</span><span style={s.rowValue}>{dateLocale(props.voucher.created_at)}</span></div>
          {lastPayment && <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'last_purchase_date')}</span><span style={s.rowValue}>{dateLocale(lastPayment.created_at)}</span></div>}
          <div style={s.row}>
            <span style={s.rowLabel}>{translator(idiom, 'voucher', 'total_value')}</span>
            <span style={s.rowValue}>
              <NumberFormat value={Number(props.voucher.total) || 0} displayType="text" decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={v => v} />
            </span>
          </div>
          <div style={s.row}>
            <span style={s.rowLabel}>{translator(idiom, 'voucher', 'paid_value')}</span>
            <span style={{ ...s.rowValue, color: '#22c55e' }}>
              <NumberFormat value={paidTotal} displayType="text" decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={v => v} />
            </span>
          </div>
          {lastPayment && (
            <div style={s.row}>
              <span style={s.rowLabel}>{translator(idiom, 'voucher', 'pending_value')}</span>
              <span style={{ ...s.rowValue, color: '#f59e0b' }}>
                <NumberFormat value={Number(lastPayment.pending_total) || 0} displayType="text" decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={v => v} />
              </span>
            </div>
          )}
          <div style={s.rowLast}>
            <span style={s.rowLabel}>{translator(idiom, 'voucher', 'payment_status')}</span>
            <span style={s.badge(payStatus.color)}>{payStatus.label}</span>
          </div>
        </div>

        {/* ── Passeios ── */}
        <p style={{ fontSize: '12px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px', marginTop: '20px', marginBottom: '4px' }}>
          {translator(idiom, 'voucher', 'about_reservation')}
        </p>

        {props.voucher.status === 'canceled' && (
          <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: '8px', padding: '12px 16px', marginTop: '8px', color: '#b91c1c', fontSize: '13px' }}>
            {tr('canceled_notice')} {props.voucher.logs?.name} — <Moment format="DD/MM/YYYY HH:mm" date={props.voucher.logs?.created_at} />
          </div>
        )}

        {props.voucher.reservations.map((v, idx) => {
          // Fix (2026-08-18): "price" já vem com o desconto gerencial aplicado
          // (embutido, sem valor separado gravado — ver pendência migration
          // manager_discount_value). Só customer_discount (PIX/cartão) é
          // subtraído à parte no Subtotal/Total. Por isso aqui mostramos só o
          // percentual, informativo — tentar "recalcular" um R$ separado
          // inflava a linha sem refletir no Total e não batia a soma.
          // Fix (2026-08-18): transfer nunca tem desconto gerencial (regra de negócio
          // confirmada) — mesmo se a reserva tiver manager_discount_pct gravado (dado
          // histórico, herdado indevidamente do desconto do pacote inteiro na conversão),
          // não pode aparecer aqui. Daqui pra frente o backend já grava 0 pra transfer
          // (ReservationController::registerTravels), isso é só uma segunda trava na exibição.
          const managerPct = v?.type === 'tour' ? (Number(v?.manager_discount_pct) || 0) : 0;
          // Fix (2026-08-19): agora que payment_discount_pct é gravado na reserva
          // (ReservationController::registerTravels), dá pra reconstituir a cadeia
          // completa de descontos: sub (bruto) → afterManual (- customer_discount)
          // → afterGerencial (managerPct) → price (paymentPct). Mesma trava de
          // transfer nunca ter desconto.
          const paymentDiscPct = v?.type === 'tour' ? (Number(v?.payment_discount_pct) || 0) : 0;
          const priceVal = Number(v?.price) || 0;
          const customerDiscountVal = Number(v?.customer_discount) || 0;
          const afterManual = priceVal / ((1 - managerPct / 100) * (1 - paymentDiscPct / 100));
          const subtotalVal = afterManual + customerDiscountVal;
          return (
          <div key={idx} style={s.tourCard}>
            <div style={{ ...s.tourName, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
              <span>
                {v?.type === 'tour' ? (idiom !== 'PT' && v?.site_titulo ? v.site_titulo : v?.travel.name) : v?.travel.region_name}
                {v?.type === 'transfer' ? ` (${tr('transfer')} ${v?.transfer_type})` : ''}
              </span>
              {managerPct > 0 && (
                <span style={{ fontSize: '11px', fontWeight: 700, color: '#6d28d9', background: '#ede9fe', borderRadius: '6px', padding: '3px 8px', whiteSpace: 'nowrap' }}>
                  {tr('manager_discount_badge')}
                </span>
              )}
            </div>
            <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'date')}</span><span style={s.rowValue}>{formatDate(v?.tour_date)}</span></div>
            <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'schedule')}</span><span style={s.rowValue}>{v?.times !== null ? getTimes(v) : formatHour(v?.flight_time) || '-'}</span></div>
            {v?.type === 'tour' && <>
              <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'adults')}</span><span style={s.rowValue}>{v?.adults_total}</span></div>
              <div style={s.row}>
                <span style={s.rowLabel}>{translator(idiom, 'voucher', 'value_by_adult')}</span>
                <span style={s.rowValue}><NumberFormat value={calcAdultsValue(v)} displayType="text" decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={v => v} /></span>
              </div>
              {Number(v?.kids_total) > 0 && <>
                <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'kids')}</span><span style={s.rowValue}>{v?.kids_total}</span></div>
                <div style={s.row}>
                  <span style={s.rowLabel}>{translator(idiom, 'voucher', 'value_by_kid')}</span>
                  <span style={s.rowValue}><NumberFormat value={calcKidsValue(v)} displayType="text" decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={v => v} /></span>
                </div>
              </>}
            </>}
            {v?.type === 'transfer' && <>
              <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'passagers')}</span><span style={s.rowValue}>{v?.adults_total}</span></div>
              <div style={s.row}>
                <span style={s.rowLabel}>{translator(idiom, 'voucher', 'value_by_passagers')}</span>
                <span style={s.rowValue}><NumberFormat value={Number(v?.adults_total_amount) || 0} displayType="text" decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={v => v} /></span>
              </div>
            </>}
            <div style={s.row}>
              <span style={s.rowLabel}>{translator(idiom, 'voucher', 'subtotal')}</span>
              <span style={s.rowValue}><NumberFormat value={subtotalVal || 0} displayType="text" decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={v => v} /></span>
            </div>
            {customerDiscountVal > 0 && (
              <div style={s.row}>
                <span style={s.rowLabel}>{translator(idiom, 'voucher', 'discount')}</span>
                <span style={{ ...s.rowValue, color: '#22c55e' }}>
                  <NumberFormat value={customerDiscountVal} displayType="text" decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={val => val} />
                  {' '}({subtotalVal > 0 ? ((customerDiscountVal / subtotalVal) * 100).toFixed(2) : '0.00'}%)
                </span>
              </div>
            )}
            {managerPct > 0 && (
              <div style={{ ...s.row, background: '#ede9fe', margin: '0', padding: '10px 18px' }}>
                <span style={{ ...s.rowLabel, color: '#6d28d9' }}>{tr('manager_discount_line')}</span>
                <span style={{ ...s.rowValue, color: '#6d28d9', fontWeight: 700 }}>
                  {managerPct.toFixed(2)}%
                </span>
              </div>
            )}
            {paymentDiscPct > 0 && (
              <div style={{ ...s.row, background: '#e0f2fe', margin: '0', padding: '10px 18px' }}>
                <span style={{ ...s.rowLabel, color: '#0369a1' }}>{tr('payment_discount_line')}</span>
                <span style={{ ...s.rowValue, color: '#0369a1', fontWeight: 700 }}>
                  {paymentDiscPct.toFixed(2)}%
                </span>
              </div>
            )}
            <div style={s.rowLast}>
              <span style={{ ...s.rowLabel, color: '#172B4D', fontSize: '14px' }}>{translator(idiom, 'voucher', 'total')}</span>
              <span style={{ ...s.rowValue, fontWeight: 700, color: '#172B4D', fontSize: '14px' }}><NumberFormat value={Number(v?.price) || 0} displayType="text" decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={v => v} /></span>
            </div>
          </div>
          );
        })}

        {/* ── Termos ── */}
        {(props.voucher?.terms?.description || props.voucher?.terms?.description2 || props.voucher?.terms?.description3) && (
          <div style={s.termsWrap}>
            <div style={{ fontSize: '12px', fontWeight: 700, color: '#172B4D', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '12px' }}>{tr('terms_title')}</div>
            {props.voucher?.terms?.description  && <div style={s.termsText} dangerouslySetInnerHTML={{ __html: cleanText(props.voucher.terms.description) }} />}
            {props.voucher?.terms?.description2 && <div style={{ ...s.termsText, fontWeight: 600, marginTop: '8px' }} dangerouslySetInnerHTML={{ __html: cleanText(props.voucher.terms.description2) }} />}
            {props.voucher?.terms?.description3 && <div style={{ ...s.termsText, marginTop: '8px' }} dangerouslySetInnerHTML={{ __html: cleanText(props.voucher.terms.description3) }} />}
          </div>
        )}

        {/* ── Assinatura ── */}
        <div style={{ ...s.signBox, borderColor: props.voucher?.signed_by_customer ? '#22c55e44' : '#e0e7ef' }}>
          {props.voucher?.signed_by_customer ? (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
                <span style={{ fontSize: '24px' }}>✅</span>
                <div>
                  <div style={{ fontWeight: 700, color: '#22c55e', fontSize: '15px' }}>{tr('signed_title')}</div>
                  <div style={{ fontSize: '12px', color: '#64748b', marginTop: '2px' }}>{dateLocale(props.voucher?.signature_date)}</div>
                </div>
              </div>
              <div style={{ fontSize: '12px', color: '#555', lineHeight: '1.6' }}>
                <strong>{props.voucher?.customerData?.email}</strong> · {translator(idiom, 'voucher', 'document')} {props.voucher?.customerData?.document} · IP {props.voucher?.signature_ip}
              </div>
              {props.voucher?.signatures?.public_key && (
                <div>
                  <div style={{ fontSize: '10px', color: '#64748b', marginTop: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>HASH SHA256</div>
                  <div style={s.signHash}>{props.voucher.signatures.public_key}</div>
                </div>
              )}
            </>
          ) : (
            <div style={{ textAlign: 'center', padding: '8px 0' }}>
              <div style={{ fontSize: '13px', color: '#64748b' }}>{tr('waiting_signature')}</div>
            </div>
          )}
        </div>

        {/* ── Rodapé ── */}
        <div style={s.footer}>
          <div style={{ fontWeight: 700, color: '#172B4D', marginBottom: '4px' }}>{props.voucher.company.name} — Adventure & Experience</div>
          <div>{tr('purchase_date')}: {dateLocale(props.voucher.created_at)} · {tr('company_id')}: {props.voucher.id}</div>
        </div>

      </div>
    </div>;

  }
}

const VoucherLinkExit = props => {
  let { path } = useRouteMatch();
  const history = useHistory();
  const location = useLocation();
  const componentRef = useRef()
  const { sale_id, token: tokenParam } = useParams();
  // Token pode vir na rota (:token) ou no query string (?access_token=...)
  const queryToken = new URLSearchParams(location.search).get('access_token');
  const token = tokenParam || queryToken;
  const [voucher, setVoucher] = useState({});
  const [loading, setLoading] = useState(true);
  const [sendingVoucher, setSendingVoucher] = useState(false);
  let url = token ? `/customer/get_sale_voucher/${sale_id}?access_token=${token}` : `/customer/get_sale_voucher/${sale_id}?sale_id=${sale_id}`;
  const [success, setSuccess] = useState(false);
  const sendVoucherUrl = `sales/${sale_id}/send_voucher`;
  const [openModal, setOpenModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [checked, setChecked] = useState(true);
  const [loadingSignature, setLoadingSignature] = useState(false);
  const [loadingCode, setLoadingCode] = useState(false);
  const [successCode, setSuccessCode] = useState(false);
  const [ip, setIP] = useState('');
  const [code, setCode] = useState('');
  const [codeConfirm, setCodeConfirm] = useState('');
  const [error, setError] = React.useState(false);

  const getVoucher = url => {
    return apiClient.httpInstance.get(url).then(response => {
      if (response.status === 200) {
        setVoucher(response.data);
        setLoading(false);
      }
    }).catch(function (response) {
      // Não redireciona para login em rotas públicas de voucher
      setLoading(false);
    });
  }

  const sendVoucher = () => {
    setSendingVoucher(true);
    apiClient.httpInstance.post(sendVoucherUrl).then(response => {
      if (response.status === 200) {
        setSuccess(true);
        setSendingVoucher(false);
        setTimeout(() => {
          setSuccess(false);
        }, 2000);
      }
    });
  }

  const changeCodeConfirm = (value) => {
    // trim: código colado do e-mail costuma vir com espaço/quebra de linha → "chave inválida"
    setCodeConfirm((value || '').trim())
  }

  const sendSignCode = (customer_id, customer_email) => {
    if (!customer_id || customer_id === 'undefined') {
      setError(true)
      return
    }
    setLoadingCode(true)
    setSuccessCode(false)
    setError(false)
    apiClient.httpInstance.post(`sales/${sale_id}/send_code_signature/${customer_id}`, { "email": customer_email }).then(response => {
      if (response.status === 200) {
        getVoucher(url);
        setSuccessCode(true)
      }
    }).catch(() => {
      setError(true)
    }).finally(() => {
      setLoadingCode(false)
    });
  }

  const confirmSignature = () => {
    setError(false)
    if (!codeConfirm) {
      setLoadingSignature(false)
      setError(true)
      return
    }
    setLoadingSignature(true)
    apiClient.httpInstance.post(`sales/${sale_id}/sale_signature`, {
      customer_ip: ip,
      customer_hash: codeConfirm
    }).then(response => {
      if (response.status === 200) {
        getVoucher(url).then(() => {
          setOpenModal(false)
          setSuccessModal(true)
        }).catch(() => {
          setOpenModal(false)
          setSuccessModal(true)
        });
      }
    }).catch(function (response) {
      setLoadingSignature(false)
      setError(true)
    });
    ;
  }

  //creating function to load ip address from the API
  // 2026-06-05: geolocation-db.com passou a responder 403 — trocado por ipify
  const getIpClient = async () => {
    try {
      const res = await axios.get('https://api.ipify.org?format=json');
      setIP(res.data.ip);
    } catch (e) {
      try {
        const res2 = await axios.get('https://api.my-ip.io/v2/ip.json');
        setIP(res2.data.ip);
      } catch (e2) {
        // segue sem IP — backend aceita customer_ip vazio
      }
    }
  }

  useEffect(() => {
    getVoucher(url);
    getIpClient();
  }, [url]);

  // Bloqueia tradução automática do navegador (Google/Samsung Translate corrompe o
  // DOM do React — campos somem e o código OTP digitado chega corrompido). 2026-06-04
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'google';
    meta.content = 'notranslate';
    document.head.appendChild(meta);
    document.documentElement.setAttribute('translate', 'no');
    document.documentElement.classList.add('notranslate');
    return () => {
      document.head.removeChild(meta);
      document.documentElement.removeAttribute('translate');
      document.documentElement.classList.remove('notranslate');
    };
  }, []);

  let theme = AdminConfig.themes[slugfy(props?.user?.data?.permission)] || AdminConfig.themes.logistica;

  // Voucher-i18n (2026-06-05): idioma do cliente (definido na conversão) traduz toda a página
  const vIdiom = (voucher?.customerData?.language || 'pt').toUpperCase();
  const vt = (key) => translator(vIdiom, 'voucher', key);

  return <Switch>
    <React.Fragment>
      <div className="flex flex-col admin" translate="no">
        <Header theme={theme} />
        <div className="flex flex-row bg-lightgray">
          <Route path={`${path}`}>
            <div className="w-full mx-0 mb-20 pt-14" style={{ overflowX: 'hidden' }}>
              <>
                {!loading && <div className="px-4 w-full" style={{ boxSizing: 'border-box', maxWidth: '100%' }}>
                  <div className="flex items-center justify-between mt-2 text-2xl text-blue flex-wrap">
                    <div className="w-auto md:w-0">Voucher</div>
                    <div className="flex flex-wrap gap-2">
                      {voucher?.signed_by_customer ?
                        <Button
                          textcolor="#FFF"
                          padding="6px 15px"
                          width="200"
                        >
                          <Link color="inherit" to={`/sign/${sale_id}`} target='_blank'>
                            {vt('show_signature')}
                          </Link>
                        </Button>
                        :
                        <Button
                          textcolor="#FFF"
                          padding="6px 15px"
                          width="200"
                          //disabled={voucher?.signed_by_customer ? true : false}
                          onClick={() => { setOpenModal(true); sendSignCode(voucher?.customerData?.id, voucher?.customerData?.email); } }
                        >
                          {vt('sign')}
                        </Button>
                      }
                      <ReactToPrint
                        trigger={() => <Button
                          textcolor="#FFF"
                          padding="6px 15px"
                          width="200"
                        >
                          {vt('view_pdf')}
                        </Button>
                        }
                        content={() => componentRef.current}
                        pageStyle={`
                          @page { size: 10in 13.5in; margin: 10mm; }
                          @media print {
                            body { background: white !important; margin: 0; padding: 0; }
                            #desktop { display: block !important; }
                            .admin-header, header, nav { display: none !important; }
                          }
                        `}
                      />
                    </div>
                  </div>
                  <div className="my-4 d-flex">
                    {success && <Alert className="mt-5" severity="success" color="success">
                      {vt('voucher_sent')}
                    </Alert>}
                  </div>
                  {voucher && voucher.customerData && (
                    <Content
                      {...props}
                      voucher={voucher}
                      ref={componentRef}
                    />
                  )}
                </div>}
              </>
            </div>
          </Route>
        </div>
      </div>

      <Modal open={openModal} style={{ width: '90%', maxWidth: '450px' }}>
        <div className="justify-end text-center md:flex w-100">
          <Icon className="cursor-pointer" onClick={(ev) => setOpenModal(false)}>close</Icon>
        </div>
        {voucher?.signed_by_customer ?
          <><div className="flex mt-4">
            <p>{vt('signature_done_at')} {dateLocale(voucher?.signature_date)}</p>
          </div>
            <div className="flex mt-4">
              <p style={{ wordBreak: 'break-word' }}>Email: {voucher?.customerData?.email}</p>
            </div>
            <div className="flex mt-4">
              <p>CPF: {voucher?.customerData?.document}</p>
            </div>
            <div className="flex my-4">
              <p>IP: {voucher?.signature_ip}</p>
            </div>
          </>
          :
          <form>
            {error && (<Alert className="mb-5" variant="filled" severity="error">
              {vt('invalid_key')}
            </Alert>)}
            {successCode && !error && (
              <Alert className="mb-3" variant="filled" severity="success">
                {vt('code_sent_to')} {voucher?.customerData?.email}
              </Alert>
            )}
            <div className="flex mt-4" style={{ color: '#94a3b8', fontSize: '0.85rem' }}>
              <p>{vt('signer_data')}</p>
            </div>
            <div className="flex mt-2" style={{ fontSize: '0.9rem' }}>
              <p>Email: <strong>{voucher?.customerData?.email}</strong></p>
            </div>
            <div className="flex mt-1" style={{ fontSize: '0.9rem' }}>
              <p>CPF: <strong>{voucher?.customerData?.document}</strong></p>
            </div>
            <div className="flex mt-1" style={{ fontSize: '0.9rem' }}>
              <p>IP: {ip}</p>
            </div>
            <div className="flex mt-4 ml-2">
              <Checkbox
                className="p-0"
                value={checked}
                checked={checked}
                onChange={(ev) => setChecked(ev.target.checked, true)}
                color="dark"
              /><p onClick={() => setChecked(!checked)}>{vt('agree')}</p>
            </div>
            {!ip && <div className="justify-center text-center mt-4 md:flex w -100">
              <Button
                textcolor="#fff"
                padding="10px 15px"
                margintop="0px"
                width="300px"
                disabled={!checked}
                onClick={(ev) => getIpClient()}>
                {vt('update_ip')}
              </Button>
            </div>}
            <div className="mt-4" style={{ color: '#94a3b8', fontSize: '0.85rem' }}>
              <p>{vt('code_hint')}</p>
            </div>
            <div className="justify-center text-center mt-3 md:flex w -100">
              <TextField
                className="inputRounded"
                label={vt('insert_key')}
                variant="outlined"
                type="text"
                value={codeConfirm}
                onChange={(ev) => changeCodeConfirm(ev.target.value)}
                required
              />
            </div>
            <div className="justify-center text-center mt-3 md:flex w-100">
              {loadingCode ?
                <Button
                  textcolor="#62DEC2"
                  variant="outlined"
                  bgColor="transparent"
                  margintop="0px"
                  width="300px"
                  style={{ border: '1px solid #62DEC2' }}
                  disabled
                >
                  <div className="flex items-center justify-center space-x-2">
                    <CircularProgress size={16} style={{ color: '#62DEC2' }} />
                    <span>{vt('sending')}</span>
                  </div>
                </Button>
                :
                <Button
                  textcolor="#62DEC2"
                  bgColor="transparent"
                  margintop="0px"
                  width="300px"
                  style={{ border: '1px solid #62DEC2', borderRadius: '8px' }}
                  onClick={(ev) => {
                    sendSignCode(voucher?.customerData?.id, voucher?.customerData?.email)
                  }}
                >
                  <div className="flex items-center justify-center space-x-2">
                    <Icon style={{ fontSize: '16px' }}>email</Icon>
                    <span>{vt('resend_code')}</span>
                  </div>
                </Button>
              }
            </div>
            <div className="justify-center text-center my-4 md:flex w-100">
              <Button
                textcolor="#fff"
                padding="10px 15px"
                margintop="0px"
                width="300px"
                disabled={!checked}
                onClick={(ev) => {
                  confirmSignature()
                }}
              >
                {loadingSignature ?
                  <div className="flex-1 text-center">
                    <CircularProgress size={20} />
                  </div>
                  :
                  vt('confirm_signature')
                }
              </Button>
            </div>
          </form>
        }
      </Modal>

      <Modal open={successModal} style={{ width: '100%', maxWidth: '350px' }}>
        <div className="justify-end text-center md:flex w-100">
          <Icon className="cursor-pointer" onClick={(ev) => setSuccessModal(false)}>close</Icon>
        </div>
        <div className="flex mt-4">
          <p>{vt('signature_done_at')} {dateLocale(voucher?.signature_date)}</p>
        </div>
        <div className="flex mt-4">
          <p>Email: {voucher?.customerData?.email}</p>
        </div>
        <div className="flex mt-4">
          <p>CPF: {voucher?.customerData?.document}</p>
        </div>
        <div className="flex my-4">
          <p>IP: {voucher?.signature_ip}</p>
        </div>
      </Modal>
    </React.Fragment>
  </Switch>
}

const mapStateToProps = state => {
  return {
    user: state.user
  }
}

export default connect(
  mapStateToProps
)(VoucherLinkExit);
